import React from "react";
import { motion } from "framer-motion";
import CtaLink from "../../components/CtaLink";
import { aboutContent } from "./homeContent";

const HomeAbout = () => {
  const aboutImage = `${process.env.PUBLIC_URL}/assets/about-bg.webp`;

  return (
    <section
      className="bg-white py-14 lg:py-20"
      aria-labelledby="home-about-heading"
    >
      <div className="sectionlayout grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="order-2 lg:order-1"
        >
          <h2
            id="home-about-heading"
            className="text-3xl md:text-4xl font-extrabold tracking-tight text-[var(--brand-primary)]"
          >
            {aboutContent.title}
          </h2>
          <div className="mt-3 h-1 w-24 rounded-full bg-[var(--brand-orange)]" />
          <h3 className="mt-5 text-xl md:text-2xl font-bold text-gray-900">
            {aboutContent.subtitle}
          </h3>
          <div className="mt-5 space-y-4">
            {aboutContent.paragraphs.map((paragraph) => (
              <p
                key={paragraph}
                className="text-sm md:text-base leading-relaxed text-gray-600"
              >
                {paragraph}
              </p>
            ))}
          </div>
          <div className="mt-8">
            <CtaLink
              to={aboutContent.cta.to}
              label={aboutContent.cta.label}
              variant="outline"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="order-1 lg:order-2"
        >
          <img
            src={aboutImage}
            alt="MBA Solutions consultants reviewing management system documentation with a client"
            loading="lazy"
            className="w-full rounded-3xl object-cover shadow-xl"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HomeAbout;
